import { getLocalizedMessage, showMessageAlert } from '@/core/shared'

export function TemplatesManager () {
	'use strict'

	this.global = false
	this.action = null
	this.template = {}
	this.postSaveAction = function() {}

	this.init = function (properties) {
		this.global = properties.global || false
		this.action = properties.action
		this.template = properties.template
		this.postSaveAction = properties.postSaveAction
	}

	this.deleteTemplate = function (template, table) {
		Swal.fire({
			title: getLocalizedMessage('delete') + ' ' + template['name'] + '?',
			allowOutsideClick: true,
			confirmButtonText: getLocalizedMessage('ok'),
			showCancelButton: true,
			cancelButtonText: getLocalizedMessage('cancel'),
			buttonsStyling: false,
			allowEnterKey: true,
			showClass: {
				popup: ''
			},
			hideClass: {
				popup: ''
			},
			customClass: {
				confirmButton: 'uk-button uk-button-primary uk-button-small uk-margin-small-right',
				cancelButton: 'uk-button uk-button-default uk-button-small',
			}
		}).then(function (result) {
			if (result.value) {
				$.ajax({
					type: 'POST',
					url: window.urlContext + 'template/delete',
					data: { id: template['id'] },
					async: false,
					success: function () {
						table.initTable()
						showMessageAlert(getLocalizedMessage('remove.template.message'), 'success')
					},
					error: function (response) {
						if (response.status === 409) {
							showMessageAlert(getLocalizedMessage('unresolved.references.exist'), 'danger')
						} else {
							showMessageAlert(getLocalizedMessage('error'), 'danger')
						}
					}
				})
			}
		})
	}

	this.saveTemplate = function (action, templateInformation) {
		var manager = this
		var actionUrl = manager.action === 'edit' ? 'template/update' : 'template/create'

		$.ajax({
			url: window.urlContext + actionUrl,
			type: 'POST',
			data: JSON.stringify(templateInformation),
			contentType: 'application/json; charset=UTF-8',

			success: function () {
				window.table.initTable()
				showMessageAlert(getLocalizedMessage('changes.saved'), 'success')
			},
			error: function (error) {
				showMessageAlert(getLocalizedMessage('error.saving'), 'danger', error.message)
			}
		})
	}
}
